export const phoneRegExp = /\d{3}-\d{3}-\d{4}/;
export const emailRegExp = /^([a-zA-Z0-9_\-\+](?:[a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-\+])?)@([a-zA-Z0-9_\-\+\.]+)\.([a-zA-Z]{2,5})$/;
// export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,15}$/;

// This will work for '#' and other special characters
export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^[\]{}|\\\/~+-_#])[A-Za-z\d@$!%*?&^[\]{}|\\\/~+-_#]{6,15}$/;

export const eventTypes = [
    {
      label: 'Parking Motion',
      value: 'PARKING_MOTION'
    },
    {
      label: 'Parking Hit',
      value: 'PARKING_HIT'
    },
    {
      label: 'Parking Heavy Hit',
      value: 'PARKING_HEAVY_HIT'
    },
    {
      label: 'Driving Hit',
      value: 'DRIVING_HIT'
    },
    {
      label: 'Driving Heavy Hit',
      value: 'DRIVING_HEAVY_HIT'
    },
    {
      label: 'Hard Acceleration',
      value: 'HARD_ACCEL'
    },
    {
      label: 'Hard Brake',
      value: 'HARD_BRAKE'
    },
    {
      label: 'Sharp Turn',
      value: 'SHARP_TURN'
    },
    {
      label: 'Harsh Acceleration',
      value: 'HARSH_ACCEL'
    },
    {
      label: 'Harsh Brake',
      value: 'HARSH_BRAKE'
    },
    {
      label: 'Harsh Turn',
      value: 'HARSH_TURN'
    },
    {
      label: 'Severe Acceleration',
      value: 'SEVERE_ACCEL'
    },
    {
      label: 'Severe Brake',
      value: 'SEVERE_BRAKE'
    },
    {
      label: 'Severe Turn',
      value: 'SEVERE_TURN'
    },
    {
      label: 'Potential Incident Low',
      value: 'POTENTIAL_INCIDENT_LOW'
    },
    {
      label: 'Potential Incident Medium',
      value: 'POTENTIAL_INCIDENT_MEDIUM'
    },
    {
      label: 'Potential Incident High',
      value: 'POTENTIAL_INCIDENT_HIGH'
    },
    {
      label: 'Asleep',
      value: 'ASLEEP'
    },
    {
      label: 'Drowsiness',
      value: 'DROWSINESS'
    },
    {
      label: 'Yawn',
      value: 'YAWN'
    },
    {
      label: 'Daydreaming',
      value: 'DAYDREAMING'
    },
    {
      label: 'Using Phone',
      value: 'USING_PHONE'
    },
    {
      label: 'Distracted',
      value: 'DISTRACTED'
    },
    {
      label: 'Smoking',
      value: 'SMOKING'
    },
    {
      label: 'No Seatbelt',
      value: 'NO_SEATBELT'
    },
    {
      label: 'Idle No Driver',
      value: 'IDLE_NO_DRIVER'
    },
    {
      label: 'Headway Monitoring Warning',
      value: 'HEADWAY_MONITORING_WARNING'
    },
    {
      label: 'Headway Monitoring Emergency',
      value: 'HEADWAY_MONITORING_EMERGENCY'
    },
    {
      label: 'Lane Departure Warning',
      value: 'LANE_DEPARTURE_WARNING'
    },
    {
      label: 'Stop Sign Violation',
      value: 'STOP_SIGN_VIOLATION'
    },
    {
      label: 'Power Lost',
      value: 'POWER_LOST'
    },
    {
      label: 'No Driver',
      value: 'NO_DRIVER'
    },
    {
      label: 'Manual',
      value: 'MANUAL'
    },
    {
      label: 'Forward Collision Warning',
      value: 'FORWARD_COLLISION_WARNING'
    }
];

export const BANNER_VALIDATOR_TIME_IN_S = 86400;

export const DOMAIN_CONFIG = {
  'GORILLA': 'gs',
  'THIRDEYE': 'THIRDEYE',
  'VEXXAR': 'VEXXAR',
  'TRACKON': 'trackon',
  'MAPON': 'MAPON',
  'MAPANYTHING': 'MAPANYTHING',
  'SPIREON': 'spireon',
  'TRUCKERPATH': 'tp',
  'ELDMANDATE': 'em',
  'CLUTCH': 'clutch',
  'RADIUS': 'radius',
  'DVIRONLY': 'edvir',
  'WEBFLEET': 'webfleet',
  'RISKTHEORY': 'riskTheory',
  'ALLWAYSTRACK': 'at',
  'ELDX': 'eldx',
  'AZUGA': 'azuga',
  'SIMPLEX': 'simplex',
  'FLEETTRACK': 'ft',
  'HCSS': 'hcss',
  'PATRIOT': 'patriot',
  'COMMANDALKON': 'trackit',
  'NAUTO': 'nauto',
  'CYNTRX': 'cyntrx',
  'TWOBRO': '2bro',
  'TOPTRACKING': 'tts',
  'TWOBRO': '2bro',
}

export const domainList = {
  'GORILLA': 'GORILLA',
  'THIRDEYE' : 'THIRDEYE',
  'VEXXAR' : 'VEXXAR',
  'TRACKON' : 'TRACKON',
  'MAPON' : 'MAPON',
  'MAPANYTHING' : 'MAPANYTHING',
  'SPIREON' : 'SPIREON',
  'TRUCKERPATH' : 'CLEARPATHELD',
  'ELDMANDATE' : 'ELDMANDATE',
  'CLUTCH' : 'CLUTCH',
  'RADIUS' : 'RADIUS',
  'DVIRONLY' : 'DVIRONLY',
  'WEBFLEET' : 'WEBFLEET',
  'RISKTHEORY' : 'RISKTHEORY',
  'ALWAYSTRACK' : 'ALLWAYSTRACK',
  'ELDX' : 'ELDX',
  'AZUGA' : 'AZUGA',
  'SIMPLEX' : 'SIMPLEX',
  'COMMANDALKON' : 'COMMANDALKON',
  'FLEETTRACK' : 'FLEETTRACK',
  'HCSS' : 'HCSS',
  'TRACKIT': 'COMMANDALKON',
  'NAUTO': 'NAUTO',
  '2BRO': '2BRO',
  'TOPTRACKINGSYSTEM': 'TOPTRACKINGSYSTEM',
  '2BRO': '2BRO',
}

export const ADMIN_ROLES_LIST = [
  {
      label: 'Super Admin',
      value: 'SUPER_ADMIN'
  },
  {
      label: 'Support',
      value: 'SUPPORT'
  },
];


export const TIMEZONE_LIST_US_INPUT = [
  { label: 'Coordinated Universal Time', timeZoneLabel: 'UTC', timezoneId: 'UTC' },
  { label: 'Central Time (US & Canada)', timeZoneLabel: 'US/Central', timezoneId: 'CST' },
  { label: 'Eastern Time (US & Canada)', timeZoneLabel: 'US/Eastern', timezoneId: 'EST' },
  { label: 'Mountain Time (US & Canada)', timeZoneLabel: 'US/Mountain', timezoneId: 'MST' },
  { label: 'Pacific Time (US & Canada)', timeZoneLabel: 'US/Pacific', timezoneId: 'PST' },
  { label: 'Alaska Time', timeZoneLabel: 'US/Alaska', timezoneId: 'AKST' },
  { label: 'Hawaii-Aleutian Time', timeZoneLabel: 'US/Hawaii', timezoneId: 'HST' },
  { label: 'Atlantic Time (US & Canada)', timeZoneLabel: 'SystemV/AST4ADT', timezoneId: 'AST' },
  { label: 'Indiana (East)', timeZoneLabel: 'America/Indianapolis', timezoneId: 'EST' },
  { label: 'Arizona', timeZoneLabel: 'US/Arizona', timezoneId: 'MST' },
  { label: 'Chihuahua', timeZoneLabel: 'America/Chihuahua', timezoneId: 'MST' },
  { label: 'Newfoundland', timeZoneLabel: 'Canada/Newfoundland', timezoneId: 'NST' },
  { label: 'Samoa', timeZoneLabel: 'Pacific/Samoa', timezoneId: 'SST' },
  { label: 'American Samoa', timeZoneLabel: 'Pacific/Pago_Pago', timezoneId: 'SST' },
  { label: 'Guam', timeZoneLabel: 'Pacific/Guam', timezoneId: 'ChST' },
  { label: 'Marshall Islands', timeZoneLabel: 'Pacific/Majuro', timezoneId: 'MHT' },
  { label: 'Central Time (US)', timeZoneLabel: 'America/Chicago', timezoneId: 'CST' },
  { label: 'Eastern Time (US)', timeZoneLabel: 'America/New_York', timezoneId: 'EST' },
  { label: 'Mountain Time (US)', timeZoneLabel: 'America/Denver', timezoneId: 'MST' },
  { label: 'Pacific Time (US)', timeZoneLabel: 'America/Los_Angeles', timezoneId: 'PST' },
  { label: 'Alaska Time (US)', timeZoneLabel: 'America/Anchorage', timezoneId: 'AKST' },
  { label: 'Hawaii-Aleutian Time (US)', timeZoneLabel: 'America/Adak', timezoneId: 'HST' },
];


export const REQUIRED_ERROR = "This field is required";

// States

export const STATES = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MH', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI',
    'SC', 'SD', 'TN', 'TX', 'UT','VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY', 'AG', 'BJ', 'BS', 'CP', 'CH', 'CI', 'CU', 'CL', 'DF', 'DG', 'GJ', 'GR', 'HR', 'JA', 'MX', 'MR', 'NA',
    'NL', 'OA', 'PU', 'QA', 'QR', 'SL', 'SI', 'SO', 'TA', 'TM', 'TL', 'VZ', 'YC', 'ZT', 'AB', 'BC', 'MB'
].map(e => ({ label: e, value: e }))

export const INPUT_DELAY = 200;

export const LANGUAGE_MAP = { EN: 'en', SP: 'es', FR: 'fr' };
